<template>
  <div class="chat-conversations" id="conversationContainer">
    <div class="chat-conversations-header">
      <ConversationsSearch v-model="searchText" />
      <div class="d-flex align-items-center">
        <div class="mx-2 text-third" style="font-size: 18px; cursor: pointer; align-items: center;" @click="$refs.SearchOptionsModal.open()">
          <i class="fas fa-search"></i>
        </div>
      </div>
    </div>

    <SearchOptionsModal ref="SearchOptionsModal" @setFilter="handleSetFilter"/>

    <ConversationsLoading v-if="isLoading" />

    <div class="chat-conversations-list">
      <div v-for="conversation in filteredConversations" :key="conversation.conversationId"
      class="chat-conversations-list-item"
        :class="{ 'chat-conversation-selected': conversation.conversationId === selectedConversationId }"
        @click="handleConversationClick(conversation)"
        >
        <div class="chat-conversations-list-item-checkbox mr-2" v-show="localShowAllMessages">
          <input
            type="checkbox"
            :checked="selectedConversations.includes(conversation.conversationId)"
            @click.stop="toggleConversationSelection(conversation.conversationId)"
          />
        </div>
        <div class="chat-conversations-list-item-avatar">
          <img :src="getAvatar(conversation.photo)" alt="avatar" />
        </div>
        <div class="chat-conversations-list-item-info">
          <div class="chat-conversations-list-item-info-conversationid">
            {{ conversation.protocol }}
          </div>
          <div class="chat-conversations-list-item-info-name">
            <div :title="getDisplayName(conversation)">{{ getDisplayName(conversation) }} <span v-if="conversation.name.apelido">({{ conversation.name.apelido }})</span></div>
          </div>
          <div class="chat-conversations-list-item-info-message">
            {{ conversation.lastMessage == null
              ? ''
              : conversation.lastMessage.type == 'text'
                ? conversation.lastMessage.text
                : conversation.lastMessage.type == 'image'
                  ? 'Imagem'
                  : conversation.lastMessage.type == 'ptt'
                    ? 'Áudio'
                    : conversation.lastMessage.type == 'list'
                      ? 'Lista'
                      : conversation.lastMessage.type == 'document'
                        ? 'Documento'
                        : conversation.lastMessage.type == 'video'
                          ? 'Vídeo'
                          : ''
            }}
          </div>
        </div>
        <div class="chat-conversations-list-item-identify">
          <div class="chat-conversations-list-item-identify-provider">
          <img :src="`static/img/chat/providers/${conversation.provider}.png`" width="15px" alt="provider" />
        </div>
        <div class="chat-conversations-list-item-identify-countNotReads" v-if="conversation.unreaded > 0">
          {{ conversation.unreaded }}
        </div>
        </div>
      </div>
    </div>
    <div class="chat-conversations-actions">
      <!-- Botões para seleção múltipla -->
      <div v-if="selectedConversations.length > 0" class="d-flex w-100 justify-content-between">
        <b-button
          class="btn btn-sm btn-dark-gray rounded-4 flex-fill mr-2"
          size="sm"
          @click="transferirConversacoesSelecionadas"
        >
          <i class="fas fa-exchange-alt icon-btn"></i>
          <span class="d-md-down-none">&nbsp; Transferir</span>
        </b-button>
        <b-button
          class="btn btn-sm btn-danger rounded-4 flex-fill"
          size="sm"
          @click="finalizarConversacoesSelecionadas"
        >
          <i class="fas fa-check-circle icon-btn"></i>
          <span class="d-md-down-none">&nbsp; Finalizar</span>
        </b-button>
      </div>
      <!-- Botão padrão quando não há seleção -->
      <b-button
          v-else
          class="btn btn-sm btn-third rounded-4 w-100"
          size="sm"
          @click="openNewConversationModal"
        >
          <i class="fas fa-user-plus icon-btn"></i>
          <span class="d-md-down-none">&nbsp; Iniciar nova conversa</span>
        </b-button>
    </div>
    <div v-if="selectedConversations.length > 0 && selectedConversations.length < filteredConversations.length" class="chat-conversations-select-all">
      <span>Deseja selecionar todos os protocolos exibidos na tela?</span>
      <b-button variant="link" class="p-0 ml-2" @click="selectAllConversations">
        <span class="text-primary">Selecionar todos</span>
      </b-button>
    </div>

    <NewConversationModal ref="newConversationModal" @createNewConversation="getNewConversation" />
    <b-modal
      centered
      ref="modalBatchTransfer"
      title="Transferir Conversas"
    >
      <b-tabs>
        <b-tab title="Transferir">
          <label for="username-select">Selecione um usuário:</label>
          <b-form-select
            id="username-select"
            v-model="selectedUsername"
            :options="usernames"
          ></b-form-select>

          <label style="margin-top:10px" for="observation">Observação:</label>
          <SimpleToggle
            style="margin-top: 10px;"
            :value="createObservationTransfer"
            @input="createObservationTransfer = $event"
            label="Adicionar Observação"
          />

          <div v-show="createObservationTransfer">
            <div style="margin-top: 10px;">
              <b-form-textarea
                id="observation"
                v-model="observationTransfer"
                placeholder="Observação"
                maxlength="90"
              ></b-form-textarea>
              <small v-if="observationTransfer" class="text-muted">
                {{ observationTransfer.length }}/90 caracteres
              </small>
            </div>
          </div>
        </b-tab>
      </b-tabs>

      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-on:click="executeBatchTransfer"
            v-b-tooltip.hover
            :title="'Transferir'"
          >
            <i class="fa fa-angle-double-right"></i
            ><span class="d-md-down-none"> Transferir</span>
          </button>
        </div>
      </template>
    </b-modal>

    <b-modal
      centered
      ref="modalBatchFinalize"
      title="Finalizar Conversas"
    >
      <b-tabs>
        <b-tab title="Finalizar">
          <label for="tipo-select">Selecione o motivo da finalização:</label>
          <b-form-select
            id="tipo-select"
            v-model="selectedTipo"
            :options="tipos"
          ></b-form-select>

          <label style="margin-top:10px" for="observation-finalize">Observação:</label>
          <SimpleToggle
            style="margin-top: 10px;"
            :value="createObservationFinalize"
            @input="createObservationFinalize = $event"
            label="Adicionar Observação"
          />

          <div v-show="createObservationFinalize">
            <div style="margin-top: 10px;">
              <b-form-textarea
                id="observation-finalize"
                v-model="observationFinalize"
                placeholder="Observação"
                maxlength="90"
              ></b-form-textarea>
              <small v-if="observationFinalize" class="text-muted">
                {{ observationFinalize.length }}/90 caracteres
              </small>
            </div>
          </div>
        </b-tab>
      </b-tabs>

      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-on:click="executeBatchFinalize"
            v-b-tooltip.hover
            :title="'Finalizar'"
          >
            <i class="fa fa-check"></i
            ><span class="d-md-down-none"> Finalizar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ConversationsLoading from './ConversationsLoading.vue'
import ConversationsSearch from './ConversationsSearch.vue'
import ConversationsTabs from './ConversationsTabs.vue'
import NewConversationModal from '../modal/NewConversationModal.vue'
import SimpleToggle from '@/components/UI/toogleSwitch/SimpleToggle.vue'
import SearchOptionsModal from './modals/SearchOptionsModal.vue'
import {toast} from '@/shared/utils/UIHelper'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import AccountMixin from '@/store/module/account/mixin'

export default {
  name: 'Messages',
  components: {
    ConversationsSearch,
    ConversationsLoading,
    ConversationsTabs,
    NewConversationModal,
    SimpleToggle,
    SearchOptionsModal
  },
  mixins: [AccountMixin],
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    conversations: {
      type: Array,
      required: true
    },
    selectedConversationId: {
      type: String,
      required: false,
      default: null
    },
    showAllMessages: {
      type: Boolean,
      required: false,
      default: false
    },
    showSimpleToggle: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      tabs: {
        active: 'Aberto',
        items: [
          {
            value: 'Aberto'
          },
          {
            value: 'Finalizado'
          }
        ]
      },
      searchText: '',
      timer: null,
      showModalNewConversation: false,
      newConversationMessage: '',
      newConversationSubject: '',
      newConversationPerson: '',
      paramConversationId: '',
      localShowAllMessages: this.showAllMessages,
      selectedConversations: [],
      usernames: [],
      selectedUsername: null,
      createObservationTransfer: false,
      observationTransfer: '',
      tipos: [],
      selectedTipo: null,
      createObservationFinalize: false,
      observationFinalize: '',
      isProcessingBatch: false,
      searchConvesationData: {
        myConversations: true,
        teamConversations: false,
        searchByAgentId: null
      }
    }
  },
  computed: {
    filteredConversations () {
      const lowercaseText = this.searchText.toLowerCase()
      return this.conversations.filter(conversation => {
        return conversation.botId === 'NDA' && (
          (conversation.name.nome && conversation.name.nome.toLowerCase().includes(lowercaseText)) ||
          (conversation.name.apelido && conversation.name.apelido.toLowerCase().includes(lowercaseText)) ||
          conversation.conversationId.toString().toLowerCase().includes(lowercaseText) ||
          (conversation.identifier.toString().toLowerCase().includes(lowercaseText.replace(/\D/g, '')) && lowercaseText.replace(/\D/g, '') !== '') ||
          (conversation.protocol.toString().toLowerCase().includes(lowercaseText.replace(/\D/g, '')) && lowercaseText.replace(/\D/g, '') !== '')
        )
      })
    }
  },
  mounted () {
  },
  watch: {
    'tabs.active' (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('changeTab', newValue)
      }
    },
    filteredConversations: {
      handler () {
        const url = window.location.href

        const urlParams = new URLSearchParams(new URL(url).search)
        if (this.selectedConversationId === null && urlParams.get('conversationId') !== null) {
          const conversationId = urlParams.get('conversationId')
          const conversation = this.filteredConversations.find(c => c.conversationId === conversationId)
          if (conversation && this.selectedConversationId !== conversationId) {
            this.handleConversationClick(conversation)
          }
        }
      },
      deep: true
    },
    showAllMessages (newValue) {
      this.localShowAllMessages = newValue
    }
  },
  methods: {
    handleConversationClick (conversation) {
      this.$router.push({ query: { conversationId: conversation.conversationId } })
      this.$emit('selectConversation', conversation)
    },
    getDisplayName (conversation) {
      let name = 'Usuário não possui nome'
      if (conversation.name && conversation.name.nome) {
        name = conversation.name.nome
      }
      return name
    },
    getOrigemDisplayName (conversation) {
      let origem = conversation.name && conversation.name.origem ? conversation.name.origem : null
      if (origem === 'Conversa') {
        return 'Esse nome é de uma conversa'
      } else if (origem === 'Campanha') {
        return 'Esse nome é de uma campanha'
      } else if (origem === 'Pessoa') {
        return 'Esse nome é de um associado'
      } else {
        return 'Nome não registrado'
      }
    },
    openNewConversationModal () {
      this.$refs.newConversationModal.openModal()
    },
    getNewConversation (valores) {
      this.$refs.newConversationModal.closeModal()
      if (valores.existing) {
        if (valores.nameOperator == null) {
          toast.warning(`Já existe uma conversa aberta e em atendimento para esse número, sem atendente responsável`, 'Atenção')
        } else {
          toast.warning(`Já existe uma conversa aberta e em atendimento para esse número, o atendente é ${valores.nameOperator}`, 'Atenção')
        }
      }
      this.$emit('createNewConversation', valores)
    },
    getAvatar (encodedImage) {
      if (encodedImage) {
        return `data:image/png;base64,${encodedImage}`
      }

      return '/static/img/avatars/03.png'
    },
    handleToggleChange (agentId = null) {
      this.$emit('onToogleSwitchAllMessages', { showAll: this.localShowAllMessages, agentId: agentId })
    },
    handleSetFilter (data) {
      if (data.value === 0) this.localShowAllMessages = false
      else if (data.value === 1) this.localShowAllMessages = true
      else this.localShowAllMessages = false

      this.handleToggleChange(data.agentId)
    },
    toggleConversationSelection (conversationId) {
      const index = this.selectedConversations.indexOf(conversationId)
      if (index === -1) {
        this.selectedConversations.push(conversationId)
      } else {
        this.selectedConversations.splice(index, 1)
      }
      this.$emit('conversationsSelectionChanged', this.selectedConversations)
    },
    selectAllConversationsa () {
      this.selectedConversations = []
      this.filteredConversations.forEach(conversation => {
        this.selectedConversations.push(conversation.conversationId)
      })
      this.$emit('conversationsSelectionChanged', this.selectedConversations)
    },
    transferirConversacoesSelecionadas () {
      this.getUsernames()
      this.$refs.modalBatchTransfer.show()
    },
    finalizarConversacoesSelecionadas () {
      this.getTiposFinalizacao()
      this.$refs.modalBatchFinalize.show()
    },
    async getUsernames () {
      try {
        var requestConfig = {}
        if (this.account.administrador) {
          requestConfig = {
            permissions: [],
            paId: [],
            isAdm: this.account.administrador
          }
        } else {
          requestConfig = {
            permissions: this.account.permissoes,
            paId: this.account.funcionario.paId,
            isAdm: false
          }
        }
        const response = await AtendimentoRepository.GetUsenames(requestConfig)
        const { status, data } = response
        if (status === 200) {
          this.usernames = data.usernames.map(user => ({
            value: user.id,
            text: user.nome
          }))
        }
      } catch (error) {
        console.error('Erro ao buscar usuários:', error)
        this.$bvToast.toast('Erro ao buscar usuários. Tente novamente.', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      }
    },
    async getTiposFinalizacao () {
      try {
        const response = await AtendimentoRepository.GetTipos()
        const { status, data } = response
        if (status === 200) {
          this.tipos = data.tipos.map(tipo => ({
            value: tipo,
            text: tipo
          }))
        }
      } catch (error) {
        console.error('Erro ao buscar tipos de finalização:', error)
        this.$bvToast.toast('Erro ao buscar tipos de finalização. Tente novamente.', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      }
    },
    async executeBatchTransfer () {
      if (!this.selectedUsername) {
        this.$bvToast.toast('Por favor, selecione um usuário para transferência.', {
          title: 'Campo obrigatório',
          variant: 'danger',
          solid: true
        })
        return
      }
      const selectedUser = this.usernames.find(user => user.value === this.selectedUsername)
      if (!selectedUser) {
        this.$bvToast.toast('Usuário selecionado não encontrado na lista.', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
        return
      }
      if (this.isProcessingBatch) return
      this.isProcessingBatch = true
      try {
        let successCount = 0
        let errorCount = 0
        const selectedConversationDetails = this.filteredConversations.filter(
          conv => this.selectedConversations.includes(conv.conversationId)
        )
        for (const conversation of selectedConversationDetails) {
          const message = {
            conversationId: conversation.conversationId,
            operatorId: this.selectedUsername,
            username: '',
            nameOperator: selectedUser.text,
            identifier: conversation.identifier,
            name: conversation.name,
            provider: conversation.provider,
            event: 'transferir',
            deptoId: conversation.deptoId,
            protocol: conversation.protocol,
            description: this.observationTransfer,
            identifierProvider: conversation.identifierProvider
          }
          try {
            this.$emit('transferirConversacao', message)
            successCount++
          } catch (error) {
            console.error(`Erro ao transferir conversa ${conversation.conversationId}:`, error)
            errorCount++
          }
        }
        if (successCount > 0) {
          this.$bvToast.toast(`${successCount} conversa(s) transferida(s) com sucesso.`, {
            title: 'Transferência em lote',
            variant: 'success',
            solid: true
          })
        }
        if (errorCount > 0) {
          this.$bvToast.toast(`${errorCount} conversa(s) não puderam ser transferidas.`, {
            title: 'Transferência em lote',
            variant: 'warning',
            solid: true
          })
        }
        this.selectedConversations = []
        this.$emit('conversationsSelectionChanged', this.selectedConversations)
        this.$refs.modalBatchTransfer.hide()
      } catch (error) {
        console.error('Erro ao processar transferência em lote:', error)
        this.$bvToast.toast('Erro ao processar transferência em lote. Tente novamente.', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.isProcessingBatch = false
      }
    },
    async executeBatchFinalize () {
      if (!this.selectedTipo) {
        this.$bvToast.toast('Por favor, selecione um motivo para finalização.', {
          title: 'Campo obrigatório',
          variant: 'danger',
          solid: true
        })
        return
      }
      if (this.isProcessingBatch) return
      this.isProcessingBatch = true
      try {
        let successCount = 0
        let errorCount = 0
        const selectedConversationDetails = this.filteredConversations.filter(
          conv => this.selectedConversations.includes(conv.conversationId)
        )
        let operatorName = 'Operador'
        if (this.account && this.account.pessoa && this.account.pessoa.nome) {
          operatorName = this.account.pessoa.nome.replace('\t', '')
        }
        for (const conversation of selectedConversationDetails) {
          const message = {
            conversationId: conversation.conversationId,
            status: 'F',
            type: this.selectedTipo,
            observation: this.observationFinalize,
            nameOperator: operatorName,
            identifier: conversation.identifier,
            name: conversation.name,
            provider: conversation.provider,
            protocol: conversation.protocol,
            identifierProvider: conversation.identifierProvider
          }
          try {
            this.$emit('finalizarConversacao', message)
            successCount++
          } catch (error) {
            console.error(`Erro ao finalizar conversa ${conversation.conversationId}:`, error)
            errorCount++
          }
        }
        if (successCount > 0) {
          this.$bvToast.toast(`${successCount} conversa(s) finalizada(s) com sucesso.`, {
            title: 'Finalização em lote',
            variant: 'success',
            solid: true
          })
        }
        if (errorCount > 0) {
          this.$bvToast.toast(`${errorCount} conversa(s) não puderam ser finalizadas.`, {
            title: 'Finalização em lote',
            variant: 'warning',
            solid: true
          })
        }
        this.selectedConversations = []
        this.$emit('conversationsSelectionChanged', this.selectedConversations)
        this.$refs.modalBatchFinalize.hide()
      } catch (error) {
        console.error('Erro ao processar finalização em lote:', error)
        this.$bvToast.toast('Erro ao processar finalização em lote. Tente novamente.', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.isProcessingBatch = false
      }
    }
  }
}
</script>
<style lang="scss">
#conversationContainer{

  .createNewConversation {
    display: flex;
    flex-direction: column;
    font-size: 20px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-right: 10px;
  }

  .createNewConversation span:hover {
    color: #04a791;
  }

  /* .createNewConversation {
    position: flex;
    bottom: 20px;
    right: 20px;
    background-color: #04a791;
    color: white;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    cursor: pointer;
    margin-top: 10px;
  };

  .createNewConversation i {
    color: white;
  }
  .createNewConversation a {
    color: white;
  }
  .createNewConversation a:hover {
    color: white;
  } */
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/conversations/Conversations.vue